/**
 * behúzza a lehetséges direktívákat
 * @author laci
 */
import financialAccount from './financial-account';
import highchartsChart from './highcharts-chart';
import linkPreventDefault from './link-prevent-default';
import noa from './noa';
import noValidation from './no-validation';
import statusMessage from './status-message/index';
import scrollTo from './scroll-to';
import stringTimestampToDate from './string-timestamp-to-date';
import taxNumber from './tax-number';
import taxNumberOnlyLast from './tax-number-only-last';
import lessThan from './less-than';
import greaterThan from './greater-than';
import euVatNumber from './euvat-number'
import passwordValidate from './password-validate';
import passwordView from './password-view/index';
import phoneNumber from './phone-number';
import invoiceNumGreaterThan from './inovice-num-greater-than';
import dateGreaterThanEquals from './date-greater-than-equals';
import dateEarlierThanEquals from './date-earlier-than-equals';
import ebizUiFinancialSelect from './ebiz-ui-financial-select';
import downloadDocument from './document-downloader';
import ajaxInProgress from './ajax-in-progress';
import datepickerValidator from './datepicker-validator';
import copyText from './copy-text';
import stickyBelowTop from './sticky-below-top';

import hintMessage from './hint-message';
import hintService from '../services/hint-service';
import cdvValid from './cdv-valid';
import warningMessage from './warning-message';
import selectOnBlurAccount from './select-on-blur-account';
import cdvTaxNumber from './cdv-tax-number';
import printDocument from './print-document';
import ajaxLoader from './ajax-loader';
import selectOnBlur from './select-on-blur';
import ignoreMouseWheel from './ignore-mousewheel';

import registrationNumber from './registration-number';
import formatLetters from './formatLetters';
import attachmentHandler from './attachment-handler';
import fixedTextArea from './fixed-text-area';
import filePreview from './file-preview';
import autoFocus from './auto-focus';
import keyEnter from './key-enter';

export default function (app) {
	noa(app);
	scrollTo(app);
	copyText(app);
	taxNumber(app);
	phoneNumber(app);
	noValidation(app);
	passwordView(app);
	statusMessage(app);
	highchartsChart(app);
	financialAccount(app);
	passwordValidate(app);
	selectOnBlur(app);
	lessThan(app);
	greaterThan(app);
	linkPreventDefault(app);
	stringTimestampToDate(app);
	invoiceNumGreaterThan(app);
	dateGreaterThanEquals(app);
	dateEarlierThanEquals(app);
	ebizUiFinancialSelect(app);
	stickyBelowTop(app);
	downloadDocument(app);
	ajaxInProgress(app);
	datepickerValidator(app);
	hintMessage(app);
	hintService(app);
	cdvValid(app);
	warningMessage(app);
	selectOnBlurAccount(app);
	cdvTaxNumber(app);
	taxNumberOnlyLast(app);
	printDocument(app);
	ajaxLoader(app);
	registrationNumber(app);
	ignoreMouseWheel(app);
	euVatNumber(app);
	formatLetters(app);
	attachmentHandler(app);
	fixedTextArea(app);
	filePreview(app);
	autoFocus(app);
	keyEnter(app);
}
